import React from "react";
import { Alert, Button, Form, Table } from "react-bootstrap";
import { Trans, useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { useAppApi } from "@/App";
import { useRequest } from "@components/AppHook";
import { DevForm } from "@components/Forms/Fields";
import { buildFormData } from "@components/Forms/Handlers";
import { RenderForm } from "@components/Forms/Render";
import { CommonCard } from "@components/Pages";
import { scroll_to_top, url_reverse } from "@components/Utils";

export default function S3Mirrors({ gameId, header }) {
    const { t } = useTranslation();
    const { apiData, setApiData, apiUrl } = useAppApi(url_reverse("api:game:s3mirrors", { game_id: gameId }));
    const { api_post_formdata } = useRequest();

    if (!apiData) return;

    const addNewTR = () => {
        const newApiData = { ...apiData };
        if (!newApiData.s3mirr) {
            newApiData.s3mirr = [];
        }
        newApiData.s3mirr.unshift({});
        setApiData(newApiData);
    };

    const removeTR = (ind) => {
        const newApiData = { ...apiData };
        newApiData.s3mirr.splice(ind, 1);
        setApiData(newApiData);
    };

    const changeS3 = (ev, ind) => {
        const { name } = ev.target;
        const { value } = ev.target;
        const newApiData = { ...apiData };
        newApiData.s3mirr[ind][name] = value;
        setApiData(newApiData);
    };

    const onSubmit = (ev) => {
        ev.preventDefault();
        const formData = buildFormData({
            ev,
            apiData,
            submitPrefixes: Object.keys(apiData.forms_data || {}),
        });

        formData.append("s3mirr", JSON.stringify(apiData.s3mirr || []));

        api_post_formdata(ev, apiUrl, formData, {
            then: (resp) => {
                setApiData(resp);
                scroll_to_top();
            },
        });
    };

    return (
        <CommonCard header={header}>
            <Form onSubmit={onSubmit}>
                <RenderForm bareForm={true} />

                <hr className="my-4" />

                {apiData.distconfig ? (
                    <Table hover responsive className="dmg-table">
                        <thead>
                            <tr>
                                <th>
                                    S3 Endpoint <span className="asteriskField">*</span>
                                </th>
                                <th>
                                    Bucket <span className="asteriskField">*</span>
                                </th>
                                <th>
                                    AccessKeyId <span className="asteriskField">*</span>
                                </th>
                                <th>
                                    SecretKey <span className="asteriskField">*</span>
                                </th>
                                <th style={{ width: "110px" }}>
                                    <Button size="sm" variant="outline-success" onClick={addNewTR}>
                                        {t("Добавить")}
                                    </Button>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {apiData.s3mirr?.map((mirr, ind) => (
                                <tr key={`s3mirr_${ind}`}>
                                    <td>
                                        <DevForm.TextInput
                                            size="sm"
                                            required={true}
                                            name="endpoint"
                                            value={mirr.endpoint}
                                            onChange={(ev) => changeS3(ev, ind)}
                                        />
                                    </td>
                                    <td>
                                        <DevForm.TextInput
                                            size="sm"
                                            required={true}
                                            name="bucket"
                                            value={mirr.bucket}
                                            onChange={(ev) => changeS3(ev, ind)}
                                        />
                                    </td>
                                    <td>
                                        <DevForm.TextInput
                                            size="sm"
                                            required={true}
                                            name="accesskeyid"
                                            value={mirr.accesskeyid}
                                            onChange={(ev) => changeS3(ev, ind)}
                                        />
                                    </td>
                                    <td>
                                        <DevForm.TextInput
                                            size="sm"
                                            required={true}
                                            name="secretkey"
                                            value={mirr.secretkey}
                                            onChange={(ev) => changeS3(ev, ind)}
                                        />
                                    </td>
                                    <td>
                                        <Button size="sm" variant="outline-danger" onClick={() => removeTR(ind)}>
                                            {t("Удалить")}
                                        </Button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                ) : (
                    <Alert variant="warning">
                        <Trans>
                            Для настройки загрузки необходимо создать{" "}
                            <Link to={url_reverse("games:distributions", { game_id: gameId })}>
                                конфигурацию загрузки дистрибутива
                            </Link>
                        </Trans>
                    </Alert>
                )}

                <DevForm.Button variant="primary" type="submit" name="save">
                    {t("Сохранить")}
                </DevForm.Button>
            </Form>
        </CommonCard>
    );
}
